import BackgroundSwitch from "../BackgroundSwitch";
import PropTypes from "prop-types";
import React from "react";
import SkeletonProductCard from "theme/components/skeletons/ProductCard";
import styled from "theme/libs/styled";
import SmallProductCard from "../products/ProductCard/SmallProductCard";

const Wrapper = styled("div")`
    position: relative;
    display: grid;
    align-items: end;
    height: 100%;
    padding: 12px;

    ${({ theme }) => theme.above.tabletLg} {
        padding: 24px;
    }
`;

const BackgroundWrapper = styled("div")`
    position: absolute;
    inset: 0;
    border-radius: 12px;
    overflow: hidden;
`;

const ProductsWrapper = styled("div")`
    position: sticky;
    bottom: 16px;

    ${({ theme }) => theme.above.tabletLg} {
        bottom: 24px;
    }

    &[data-is-fullwidth="true"] {
        display: grid;
        grid-template-columns: 1fr;

        ${({ theme }) => theme.above.tabletSm} {
            grid-template-columns: 1fr 1fr;

            > * {
                grid-column: 2;
            }
        }
    }
`;

const ProductPromotion = ({ product, background, backgroundType, mediaQuery, isFullWidth, isThreeColumn }) => {
    const type = backgroundType ? backgroundType : typeof background === "object" ? background.type : "color";

    // The CMS stores the string "error" instead of a product object when the product could not be
    // resolved for the application (e.g. a part number that is not in that market's index). Spreading
    // that string into SmallProductCard crashes server rendering on `url.replace`, taking the whole
    // page down, so only render the card for a real product with a url.
    const resolvedProduct = product?.product;
    const hasProduct =
        !!resolvedProduct && typeof resolvedProduct === "object" && typeof resolvedProduct.url === "string";

    return (
        <Wrapper>
            <BackgroundWrapper>
                <BackgroundSwitch
                    type={type}
                    background={background}
                    mediaQuery={mediaQuery}
                    /* loading={loading} */
                />
            </BackgroundWrapper>

            <ProductsWrapper data-is-fullwidth={isFullWidth}>
                {hasProduct ? (
                    <SmallProductCard {...resolvedProduct} isThreeColumn={isThreeColumn} />
                ) : (
                    <SkeletonProductCard />
                )}
            </ProductsWrapper>
        </Wrapper>
    );
};

ProductPromotion.propTypes = {
    heading: PropTypes.string,
    headingTag: PropTypes.string,
    link: PropTypes.string,
    linkText: PropTypes.string,
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            price: PropTypes.object,
        }),
    ).isRequired,
    productsAmount: PropTypes.number,
    shouldLazyLoad: PropTypes.bool,
};

ProductPromotion.defaultProps = {
    heading: undefined,
    headingTag: "h2",
    link: "#",
    linkText: undefined,
    productsAmount: 0,
    shouldLazyLoad: true,
};

export default ProductPromotion;
